import { useNavigate } from "react-router-dom";
import { MyOldEnvironmentComponent } from "./component";
import { useContext, useEffect, useState } from "react";
import { AwsConnectionContainer } from "./aws_connection/container";
import { GitConnectionsContainer } from "./git_connections/container";
import { FullDomainNamesContainer } from "./full_domain_names/container";
import { EnvironmentsContext } from "../../contexts/environments/context";
import {
  StackStatus,
  useGetMyAlertsStackStatusLazyQuery,
  useGetMyAuthenticationStackStatusLazyQuery,
  useGetMyDeploymentsStackStatusLazyQuery,
  useGetMyGitConnectionsLazyQuery,
  useGetMyHostedZonesLazyQuery,
  useGetMyHttpApiV2StackStatusLazyQuery,
  useGetMyRestApiV1StackStatusLazyQuery,
  useGetMyVpcStackStatusLazyQuery,
  useTestMyWaffleRoleQuery,
} from "../../services/backend_gateway/__generated__/backend_gateway-types";
import { BgwContext } from "../../contexts/backend_gateway/context";
import { AlertsContext } from "../../contexts/alerts/context";
import { AlertType } from "../../contexts/alerts/type";
import { VpcContainer } from "./vpc/container";
import { AuthenticationContainer } from "./authentication/container";
import { AlertsContainer } from "./alerts/container";
import { RestApiContainer } from "./rest_api/container";
import { UtilitiesContainer } from "./utilities/container";
import { HttpApiV2Container } from "./http_api/container";

export const MyOldEnvironmentContainer = (props: { deploymentId: string }) => {
  const { deploymentId } = props;

  const { loading: envLoading, editDeployment } =
    useContext(EnvironmentsContext);
  const { bgwService } = useContext(BgwContext);
  const { addAlert } = useContext(AlertsContext);

  const navigate = useNavigate();

  const navigateToHelp = (stepId: string) => {
    navigate(`/my_old_environment/${deploymentId}/help/${stepId}`, {
      replace: true,
    });
  };

  const [awsConnectionWorks, setAwsConnectionWorks] = useState<boolean>(false);
  const [gitConnectionExists, setGitConnectionExists] =
    useState<boolean>(false);
  const [domainNamesExists, setDomainNamesExists] = useState<boolean>(false);
  const [vpcStackStatus, setVpcStackStatus] = useState<StackStatus | null>(
    null
  );
  const [authenticationStackStatus, setAuthenticationStackStatus] =
    useState<StackStatus | null>(null);
  const [alertsStackStatus, setAlertsStackStatus] =
    useState<StackStatus | null>(null);
  const [deploymentsStackStatus, setDeploymentsStackStatus] =
    useState<StackStatus | null>(null);
  const [restApiV1StackStatus, setRestApiV1StackStatus] =
    useState<StackStatus | null>(null);
  const [httpApiV2StackStatus, setHttpApiV2StackStatus] =
    useState<StackStatus | null>(null);

  const {
    data: testMyWaffleRoleData,
    loading: testMyWaffleRoleLoading,
    refetch: refetchTestMyWaffleRole,
  } = useTestMyWaffleRoleQuery({
    client: bgwService.getClient(),
    variables: { deploymentId },
    onError: (error) => {
      if (error?.message !== undefined) {
        addAlert({
          text: error.message!,
          type: AlertType.WARNING,
        });
      }
    },
  });

  const [
    getMyGitConnections,
    { data: getMyGitConnectionsData, loading: getMyGitConnectionsLoading },
  ] = useGetMyGitConnectionsLazyQuery({
    client: bgwService.getClient(),
    onError: (error) => {
      if (error?.message !== undefined) {
        addAlert({
          text: error.message!,
          type: AlertType.WARNING,
        });
      }
    },
  });

  const [
    getMyHostedZones,
    { data: getMyHostedZonesData, loading: getMyHostedZonesLoading },
  ] = useGetMyHostedZonesLazyQuery({
    client: bgwService.getClient(),
    onError: (error) => {
      if (error?.message !== undefined) {
        addAlert({
          text: error.message!,
          type: AlertType.WARNING,
        });
      }
    },
  });

  const [
    getMyVpcStackStatus,
    {
      data: getMyVpcStackStatusData,
      loading: getMyVpcStackStatusLoading,
      // refetch: refetchGetMyVpcStackStatus,
    },
  ] = useGetMyVpcStackStatusLazyQuery({
    client: bgwService.getClient(),
    fetchPolicy: "network-only",
    onError: (error) => {
      if (error?.message !== undefined) {
        addAlert({
          text: error.message!,
          type: AlertType.WARNING,
        });
      }
    },
  });

  const [
    getMyAuthenticationStackStatus,
    {
      data: getMyAuthenticationStackStatusData,
      loading: getMyAuthenticationStackStatusLoading,
    },
  ] = useGetMyAuthenticationStackStatusLazyQuery({
    client: bgwService.getClient(),
    fetchPolicy: "network-only",
    onError: (error) => {
      if (error?.message !== undefined) {
        addAlert({
          text: error.message!,
          type: AlertType.WARNING,
        });
      }
    },
  });

  const [
    getMyAlertsStackStatus,
    {
      data: getMyAlertsStackStatusData,
      loading: getMyAlertsStackStatusLoading,
    },
  ] = useGetMyAlertsStackStatusLazyQuery({
    client: bgwService.getClient(),
    fetchPolicy: "network-only",
    onError: (error) => {
      if (error?.message !== undefined) {
        addAlert({
          text: error.message!,
          type: AlertType.WARNING,
        });
      }
    },
  });

  const [
    getMyDeploymentsStackStatus,
    {
      data: getMyDeploymentsStackStatusData,
      loading: getMyDeploymentsStackStatusLoading,
    },
  ] = useGetMyDeploymentsStackStatusLazyQuery({
    client: bgwService.getClient(),
    fetchPolicy: "network-only",
    onError: (error) => {
      if (error?.message !== undefined) {
        addAlert({
          text: error.message!,
          type: AlertType.WARNING,
        });
      }
    },
  });

  const [
    getMyRestApiV1StackStatus,
    {
      data: getMyRestApiV1StackStatusData,
      loading: getMyRestApiV1StackStatusLoading,
    },
  ] = useGetMyRestApiV1StackStatusLazyQuery({
    client: bgwService.getClient(),
    fetchPolicy: "network-only",
    onError: (error) => {
      if (error?.message !== undefined) {
        addAlert({
          text: error.message!,
          type: AlertType.WARNING,
        });
      }
    },
  });

  const [
    getMyHttpApiV2StackStatus,
    {
      data: getMyHttpApiV2StackStatusData,
      loading: getMyHttpApiV2StackStatusLoading,
    },
  ] = useGetMyHttpApiV2StackStatusLazyQuery({
    client: bgwService.getClient(),
    fetchPolicy: "network-only",
    onError: (error) => {
      if (error?.message !== undefined) {
        addAlert({
          text: error.message!,
          type: AlertType.WARNING,
        });
      }
    },
  });

  const retestMyWaffleRole = async () => {
    await refetchTestMyWaffleRole();
  };

  useEffect(() => {
    if (testMyWaffleRoleData) {
      const passed = testMyWaffleRoleData.testMyWaffleRole?.passed || false;
      setAwsConnectionWorks(() => passed);
      if (passed) {
        getMyGitConnections({
          variables: {
            deploymentId,
          },
          fetchPolicy: "network-only",
          onCompleted: (data) => {
            setGitConnectionExists(
              (prev) => (data.getMyGitConnections?.length || 0) > 0
            );
          },
        });
        getMyHostedZones({
          variables: {
            deploymentId,
          },
          fetchPolicy: "network-only",
          onCompleted: (data) => {
            setDomainNamesExists(
              (prev) => (data.getMyHostedZones?.length || 0) > 0
            );
          },
        });
        getMyVpcStackStatus({
          variables: {
            deploymentId,
          },
          fetchPolicy: "network-only",
          onCompleted: (data) => {
            setVpcStackStatus(data.getMyVpcStackStatus || null);
          },
        });
        getMyAuthenticationStackStatus({
          variables: {
            deploymentId,
          },
          fetchPolicy: "network-only",
          onCompleted: (data) => {
            setAuthenticationStackStatus(
              data.getMyAuthenticationStackStatus || null
            );
          },
        });
        getMyAlertsStackStatus({
          variables: {
            deploymentId,
          },
          fetchPolicy: "network-only",
          onCompleted: (data) => {
            setAlertsStackStatus(data.getMyAlertsStackStatus || null);
          },
        });
        getMyDeploymentsStackStatus({
          variables: {
            deploymentId,
          },
          fetchPolicy: "network-only",
          onCompleted: (data) => {
            setDeploymentsStackStatus(data.getMyDeploymentsStackStatus || null);
          },
        });
        getMyRestApiV1StackStatus({
          variables: {
            deploymentId,
          },
          fetchPolicy: "network-only",
          onCompleted: (data) => {
            setRestApiV1StackStatus(data.getMyRestApiV1StackStatus || null);
          },
        });
        getMyHttpApiV2StackStatus({
          variables: {
            deploymentId,
          },
          fetchPolicy: "network-only",
          onCompleted: (data) => {
            setHttpApiV2StackStatus(data.getMyHttpApiV2StackStatus || null);
          },
        });
      } else {
        setGitConnectionExists(false);
        setDomainNamesExists(false);
        setVpcStackStatus(null);
        setAuthenticationStackStatus(null);
        setAlertsStackStatus(null);
        setDeploymentsStackStatus(null);
        setRestApiV1StackStatus(null);
        setHttpApiV2StackStatus(null);
      }
    }
  }, [
    testMyWaffleRoleData,
    deploymentId,
    getMyGitConnections,
    getMyHostedZones,
    getMyVpcStackStatus,
    getMyAuthenticationStackStatus,
    getMyAlertsStackStatus,
    getMyDeploymentsStackStatus,
    getMyRestApiV1StackStatus,
    getMyHttpApiV2StackStatus,
  ]);

  useEffect(() => {
    setGitConnectionExists(
      (prev) => (getMyGitConnectionsData?.getMyGitConnections?.length || 0) > 0
    );
  }, [getMyGitConnectionsData]);

  useEffect(() => {
    setDomainNamesExists(
      (prev) => (getMyHostedZonesData?.getMyHostedZones?.length || 0) > 0
    );
  }, [getMyHostedZonesData]);

  useEffect(() => {
    setVpcStackStatus(
      (prev) => getMyVpcStackStatusData?.getMyVpcStackStatus || null
    );
  }, [getMyVpcStackStatusData]);

  useEffect(() => {
    setAuthenticationStackStatus(
      (prev) =>
        getMyAuthenticationStackStatusData?.getMyAuthenticationStackStatus ||
        null
    );
  }, [getMyAuthenticationStackStatusData]);

  useEffect(() => {
    setAlertsStackStatus(
      (prev) => getMyAlertsStackStatusData?.getMyAlertsStackStatus || null
    );
  }, [getMyAlertsStackStatusData]);

  useEffect(() => {
    setDeploymentsStackStatus(
      (prev) =>
        getMyDeploymentsStackStatusData?.getMyDeploymentsStackStatus || null
    );
  }, [getMyDeploymentsStackStatusData]);

  useEffect(() => {
    setRestApiV1StackStatus(
      (prev) => getMyRestApiV1StackStatusData?.getMyRestApiV1StackStatus || null
    );
  }, [getMyRestApiV1StackStatusData]);

  useEffect(() => {
    setHttpApiV2StackStatus(
      (prev) => getMyHttpApiV2StackStatusData?.getMyHttpApiV2StackStatus || null
    );
  }, [getMyHttpApiV2StackStatusData]);

  const awsConnectionComponent = (
    <AwsConnectionContainer
      deploymentId={deploymentId}
      navigateToHelp={navigateToHelp}
      awsConnectionWorks={awsConnectionWorks}
      refetchTestMyWaffleRole={retestMyWaffleRole}
    />
  );
  const gitConnectionsComponent = (
    <GitConnectionsContainer
      deploymentId={deploymentId}
      navigateToHelp={navigateToHelp}
    />
  );
  const domainNamesComponent = (
    <FullDomainNamesContainer
      deploymentId={deploymentId}
      navigateToHelp={navigateToHelp}
    />
  );
  const vpcComponent = (
    <VpcContainer
      deploymentId={deploymentId}
      navigateToHelp={navigateToHelp}
      vpcStackStatus={vpcStackStatus}
    />
  );
  const authenticationComponent = (
    <AuthenticationContainer
      deploymentId={deploymentId}
      navigateToHelp={navigateToHelp}
      authenticationStackStatus={authenticationStackStatus}
    />
  );

  const alertsComponent = (
    <AlertsContainer
      deploymentId={deploymentId}
      navigateToHelp={navigateToHelp}
      alertsStackStatus={alertsStackStatus}
    />
  );

  const restApiV1Component = (
    <RestApiContainer
      deploymentId={deploymentId}
      navigateToHelp={navigateToHelp}
      restApiStackStatus={restApiV1StackStatus}
    />
  );

  const httpApiV2Component = (
    <HttpApiV2Container
      deploymentId={deploymentId}
      navigateToHelp={navigateToHelp}
      httpApiStackStatus={httpApiV2StackStatus}
    />
  );

  const utilitiesComponent = (
    <UtilitiesContainer
      deploymentId={deploymentId}
      navigateToHelp={navigateToHelp}
      utilitiesStackStatus={deploymentsStackStatus}
    />
  );

  const editDeploymentName = (name: string) => {
    editDeployment(deploymentId, name);
  };

  return (
    <MyOldEnvironmentComponent
      deploymentId={deploymentId}
      loading={
        envLoading ||
        testMyWaffleRoleLoading ||
        getMyGitConnectionsLoading ||
        getMyHostedZonesLoading ||
        getMyVpcStackStatusLoading ||
        getMyAuthenticationStackStatusLoading ||
        getMyAlertsStackStatusLoading ||
        getMyDeploymentsStackStatusLoading ||
        getMyRestApiV1StackStatusLoading ||
        getMyHttpApiV2StackStatusLoading
      }
      awsConnectionWorks={awsConnectionWorks}
      gitConnectionExists={gitConnectionExists}
      domainNamesExists={domainNamesExists}
      vpcStackStatus={vpcStackStatus}
      authenticationStackStatus={authenticationStackStatus}
      alertsStackStatus={alertsStackStatus}
      restApiV1StackStatus={restApiV1StackStatus}
      httpApiV2StackStatus={httpApiV2StackStatus}
      utilitiesStackStatus={deploymentsStackStatus}
      awsConnectionComponent={awsConnectionComponent}
      gitConnectionsComponent={gitConnectionsComponent}
      domainNamesComponent={domainNamesComponent}
      vpcComponent={vpcComponent}
      authenticationComponent={authenticationComponent}
      alertsComponent={alertsComponent}
      restApiV1Component={restApiV1Component}
      httpApiV2Component={httpApiV2Component}
      utilitiesComponent={utilitiesComponent}
      editDeploymentName={editDeploymentName}
      navigateToHelp={navigateToHelp}
    />
  );
};
